require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-visa-purchase-alerts-and-visa-checkout.json") })
        }
      }, "path---es-visa-purchase-alerts-and-visa-checkout");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-visa-purchase-alerts-and-visa-checkout!./.cache/json/es-visa-purchase-alerts-and-visa-checkout.json
// module id = 2555
// module chunks = 231608221292675